import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Homework } from '../models/homework';
import { AppSettings } from '../../../../utils/app-settings';
import { PreSignedUrl } from 'src/app/models/pre-signed-url';

@Injectable()
export class HomeworksService {

  constructor(public http: HttpClient, private datePipe: DatePipe) { }

  getHomeworks(): Observable<Array<Homework>> {
    return this.http.get<Array<Homework>>(AppSettings.apiUrl + "homeworks");
  }

  //both active and completed
  GetHomeworksByDateRange(startDate: Date, endDate: Date): Observable<Array<Homework>> {
    let strStartDate = this.datePipe.transform(startDate, "yyyy-MM-dd");
    let strEndDate = this.datePipe.transform(endDate, "yyyy-MM-dd");
    return this.http.get<Array<Homework>>(AppSettings.apiUrl + "homeworks/GetHomeworksByDateRange?startDate=" + strStartDate + "&endDate=" + strEndDate);
  }

  getPresignedUrl(homeworkId: number, homeworkDocId: number): Observable<PreSignedUrl>{
    return this.http.get<PreSignedUrl>(AppSettings.apiUrl + "homeworks/" + homeworkId + "/attachments/" + homeworkDocId);
  }

  getHomeworkById(homeworkId: number): Observable<Homework>{
    return this.http.get<Homework>(AppSettings.apiUrl + "homeworks/" + homeworkId);
  }

  submitHomework(homeworkId: number, description: string, fileKeys?: Array<number>){
    return this.http.post(AppSettings.apiUrl + "homeworks/" + homeworkId + "/submit", 
    {
      "description": description,
      "file_keys": fileKeys
    });
  }
}
